@use "../../styles/breakpoint.module.scss" as *;

.root {
    composes: inherit from "../../styles/layout.module.scss";
    display: grid;
    grid-template-columns: max-content 1fr;
    /* stylelint-disable declaration-block-no-redundant-longhand-properties */
    column-gap: var(--spacer-16);
    row-gap: var(--spacer-12);
    /* stylelint-enable declaration-block-no-redundant-longhand-properties */
    align-items: center;

    [role="separator"] {
        grid-column: 1 / -1;
    }

    dd {
        margin-left: 0;
        gap: var(--spacer-4);
    }

    address {
        font-style: normal;
    }

    @media ($below-mobile) {
        grid-template-columns: 1fr;
    }
}

.label {
    composes: fontB16 from "../../styles/typography.module.scss";
    align-self: self-start;

    &:has(+ .text > .pill) {
        transform: translateY(var(--spacer-4));
    }
}

.text {
    composes: fontST16 from "../../styles/typography.module.scss";
    composes: pillGroup from "../Clickables/index.module.scss";
}

.pill {
    composes: pill from "../Clickables/index.module.scss";
    padding-block: var(--spacer-4);
    border-color: var(--mid-gray);
}
